import { defineComponent } from 'vue';
import Modal from '@common/layout/Modal.vue';
import ButtonGroup from '@common/layout/ButtonGroup.vue';
import { Form as ValidationForm } from 'vee-validate/compat';
import { translator } from '~/zf/frontend/common/mixins';
import Mode from '../../const/Mode';
import CreateBody from '../molecules/CreateBody.vue';
import EditBody from '../molecules/EditBody.vue';
import ReactivateBody from '../molecules/ReactivateBody.vue';
import ApiService from '../../../../../administration/pages/viiu/muteAndAutoClose/services/ApiService';
import MappingService from '../../services/MappingService';
import AlertService from '~/zf/frontend/common/alert/AlertService';
import ScheduledBody from '../molecules/ScheduledBody.vue';
export default defineComponent({
    name: 'ComponentMutingModal',
    compatConfig: {
        MODE: 3,
    },
    components: {
        ScheduledBody,
        ReactivateBody,
        CreateBody,
        EditBody,
        ButtonGroup,
        Modal,
        ValidationForm,
    },
    mixins: [translator],
    emits: ['reload'],
    expose: ['show'],
    data() {
        return {
            Mode,
            showModal: false,
            config: null,
            isLoading: false,
            mode: Mode.CREATE,
        };
    },
    computed: {
        modalTitle() {
            if (this.mode === Mode.EDIT) {
                return this.tr('viiu.componentMuting.EDIT_MUTING');
            }
            if (this.mode === Mode.REACTIVATE) {
                return this.tr('viiu.componentMuting.REACTIVATE_COMPONENT');
            }
            if (this.mode === Mode.SCHEDULE) {
                return this.tr('viiu.componentMuting.NEW_MUTING');
            }
            return this.tr('viiu.componentMuting.MUTE_AFFECTED_COMPONENT');
        },
        modalDescription() {
            if (this.mode === Mode.CREATE) {
                return this.tr('viiu.componentMuting.MUTE_AFFECTED_COMPONENTS_DESCRIPTION');
            }
            if (this.mode === Mode.REACTIVATE) {
                return this.tr('viiu.componentMuting.REACTIVATE_COMPONENTS_DESCRIPTION');
            }
            if (this.mode === Mode.SCHEDULE) {
                return this.tr('viiu.componentMuting.MUTE_FOR_DURATION_TO_AVOID_ALARMS');
            }
            return '';
        },
        primaryButtonText() {
            if (this.mode === Mode.CREATE) {
                return this.tr('viiu.componentMuting.MUTE_COMPONENT');
            }
            if (this.mode === Mode.REACTIVATE) {
                return this.tr('viiu.componentMuting.REACTIVATE_COMPONENT');
            }
            if (this.mode === Mode.SCHEDULE) {
                return this.tr('viiu.componentMuting.SAVE_NEW_MUTING');
            }
            return this.tr('common.SAVE_CHANGES');
        },
        primaryButtonIcon() {
            if (this.mode === Mode.CREATE) {
                return 'bell-disabled';
            }
            if (this.mode === Mode.REACTIVATE) {
                return 'bell2';
            }
            return 'floppy-disk';
        },
    },
    methods: {
        show(config, mode) {
            this.config = config;
            this.mode = mode;
            this.showModal = true;
        },
        async onConfirm() {
            const { valid } = await this.$refs.validator.validate();
            if (!valid)
                return;
            try {
                if (!this.config)
                    return;
                this.isLoading = true;
                const mappedConfig = MappingService.mapConfiguration(this.config, this.mode);
                await ApiService.run(mappedConfig, this.mode);
                const successMessages = {
                    [Mode.CREATE]: 'viiu.componentMuting.CREATE_SUCCESSFUL',
                    [Mode.EDIT]: 'viiu.componentMuting.EDIT_SUCCESSFUL',
                    [Mode.REACTIVATE]: 'viiu.componentMuting.RESUME_SUCCESSFUL',
                    [Mode.SCHEDULE]: 'viiu.componentMuting.CREATE_SUCCESSFUL',
                };
                AlertService.showSuccess(this.tr(successMessages[this.mode]));
                this.showModal = false;
                this.$emit('reload');
            }
            catch {
                const errorMessages = {
                    [Mode.CREATE]: 'viiu.componentMuting.CREATE_FAILED',
                    [Mode.EDIT]: 'viiu.componentMuting.EDIT_FAILED',
                    [Mode.REACTIVATE]: 'viiu.componentMuting.RESUME_FAILED',
                    [Mode.SCHEDULE]: 'viiu.componentMuting.CREATE_FAILED',
                };
                AlertService.showError(this.tr(errorMessages[this.mode]));
            }
            finally {
                this.isLoading = false;
            }
        },
        clearConfig() {
            this.config = null;
        },
    },
});
